import { ServiceRFQ2s } from '@/services/RFQ2s'

export default ({ employeeID }) => ({
  id: 'rfq2',
  mode: {
    isModalNew: true
  },
  store: {
    get: {
      url: ServiceRFQ2s.apiGetDynamic,
      selected: [
        'id', 'rfqid', 'entryDate', 'part.partNumber as partNumber', 'employee.name as employeeName',
        'condition.title as conditionTitle',
        'supplierCompany.name as supplierName', 'qty', 'Convert.ToString(price) + currency.title as priceCurrency',
        'partSN', 'remarks'
      ].join(','),
      ...(
        employeeID
          ? { filters: `employeeID == ${employeeID}` }
          : {}
      ),
      orderBy: {
        field: 'id',
        order: 'desc'
      }
    },
    create: {
      url: ServiceRFQ2s.apiPost
    },
    patch: {
      url: `${ServiceRFQ2s.apiPatch}/\${data.id}`
    },
    delete: {
      url: `${ServiceRFQ2s.apiDelete}/\${data.id}`
    }
  },
  header: {
    controls: {
      isVisible: false
    }
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('entry-date')}",
      field: 'entryDate',
      template: 'date'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('supplier')}",
      field: 'supplierName',
      sortable: {
        custom: 'supplierCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('part-number')}",
      field: 'partNumber',
      sortable: {
        custom: 'part.partNumber'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('part-sn')}",
      field: 'partSN'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('condition')}",
      field: 'conditionTitle',
      sortable: {
        custom: 'condition.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('qty')}",
      field: 'qty'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('price')}",
      field: 'priceCurrency',
      sortable: {
        custom: 'price'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('rfq-id')}",
      field: 'rfqid'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('remarks')}",
      field: 'remarks'
    }
  ],
  toolbar: {
    filters: [
      {
        type: 'string',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('search')}",
          // eslint-disable-next-line no-template-curly-in-string
          valueTemplate: ({ value }) => `(part.partNumber.StartsWith("${value}") || partSN.contains("${value}") )`,
          styles: {
            minWidth: '6rem'
          }
        }
      },
      ...(
        employeeID
          ? []
          : [{
            type: 'select',
            field: 'employeeID',
            // eslint-disable-next-line no-template-curly-in-string
            label: "${root.L10n('employee')}",
            options: {
              dataSource: 'Employees/GetAllDynamic?select=id,name&filter=isActive==true&OrderBy=name',
              // eslint-disable-next-line no-template-curly-in-string
              placeholder: "${root.L10n('all')}",
              option: {
                label: 'name'
              },
              styles: {
                minWidth: '8rem'
              }
            }
          }]
      ),
      {
        type: 'selectautocomplete',
        field: 'supplierCompanyID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('supplier-company')}",
        options: {
          filterTemplate: ({ data: { search } }) => `name.StartsWith("${search}")`,
          dataSource: {
            url: 'Companies/GetAllDynamic',
            selected: 'id,name',
            take: 50
          },
          option: {
            label: 'name'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}",
          styles: {
            minWidth: '15rem'
          }
        }
      },
      {
        type: 'datemultiple',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('entry-date')}",
        field: 'entryDate',
        options: {
          styles: {
            minWidth: '18rem'
          },
          tabs: [0, 2, 3]
        }
      }
    ]
  },
  rowControls: {
    right: {
      controls: ['edit']
    }
  }
})
